const CACHE_PREFIX = "sfarm_offline_v2";

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
};

const getUserScope = () => {
  const user = getStoredUser();
  const identity =
    user?.id ??
    user?.user_id ??
    user?.username ??
    user?.phone_num1 ??
    "current";

  return encodeURIComponent(String(identity));
};

const buildCacheKey = (name, identity = "") => {
  const suffix = identity === "" ? "" : `:${encodeURIComponent(String(identity))}`;
  return `${CACHE_PREFIX}:${getUserScope()}:${name}${suffix}`;
};

export const readOfflineCache = (name, identity = "") => {
  try {
    const rawValue = localStorage.getItem(buildCacheKey(name, identity));
    if (!rawValue) return null;

    const parsedValue = JSON.parse(rawValue);
    if (!parsedValue || parsedValue.version !== 2) return null;

    return {
      data: parsedValue.data,
      savedAt: parsedValue.savedAt || "",
    };
  } catch (error) {
    console.warn("Offline cache read failed:", error);
    return null;
  }
};

export const writeOfflineCache = (name, identity = "", data) => {
  if (data === undefined) return;

  try {
    localStorage.setItem(
      buildCacheKey(name, identity),
      JSON.stringify({
        version: 2,
        savedAt: new Date().toISOString(),
        data,
      }),
    );
  } catch (error) {
    console.warn("Offline cache write failed:", error);
  }
};

export const removeOfflineCache = (name, identity = "") => {
  try {
    localStorage.removeItem(buildCacheKey(name, identity));
  } catch (error) {
    console.warn("Offline cache remove failed:", error);
  }
};

